import {
  GetMemberGroupsRequest,
  Group
} from 'supporter';
import { api } from '@/api';
import { ActionContext } from 'vuex';

interface MemberGroupState {
  memberGroups: Group[];
  menberHibitInfo: any
}

export default {
  namespaced: true,
  state: {
    memberGroups: [],
    menberHibitInfo: { a: 1 }
  },
  actions: {
    async fetchMemberGroups({ commit }: ActionContext<MemberGroupState, any>, request: GetMemberGroupsRequest): Promise<any> {
      commit('SET_MEMBER_GROUP', null);

      return api.getMemberGroups(request).then((ret): void => {
        commit('SET_MEMBER_GROUP', ret!.data);
      });
    }
  },
  mutations: {
    SET_MEMBER_GROUP(state: MemberGroupState, groups: Group[]): void {
      state.memberGroups = groups;
    }
  },
  getters: {
    memberGroupList(state: MemberGroupState): Group[] {
      return state.memberGroups;
    }
  }
};
